import { render, staticRenderFns } from "./LiveTopData.vue?vue&type=template&id=561a888d&scoped=true"
import script from "./LiveTopData.vue?vue&type=script&lang=js"
export * from "./LiveTopData.vue?vue&type=script&lang=js"
import style0 from "./LiveTopData.vue?vue&type=style&index=0&id=561a888d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a888d",
  null
  
)

export default component.exports